import { JourneyDraft, UpdateDraft } from '../../../draft';
import { journeyCompleteSchema } from '../../../jsonSchemas';
import JsonField from '../JsonField/JsonField';
import PanelHeader from '../PanelHeader/PanelHeader';

interface JourneyCompletePanelProps {
  draft: JourneyDraft;
  update: UpdateDraft;
}

const JourneyCompletePanel = ({ draft, update }: JourneyCompletePanelProps) => {
  const { arc, takeaway } = draft.journeyComplete;

  return (
    <div className="grid gap-6">
      <PanelHeader
        eyebrow={draft.title || 'Untitled journey'}
        title="Journey complete"
        icon={<span className="text-2xl">🏆</span>}
      />
      <p className="text-sm text-neutral-60">
        The screen after the last mile: the journey’s arc in the author’s words — one line per mile,
        in <code>arc.miles</code> — and what to take away.
      </p>
      <div className="grid gap-3">
        <h3 className="text-lg font-semibold text-neutral-90">Content (JSON)</h3>
        <JsonField
          key={draft.miles.length}
          value={{
            arc: { ...arc, miles: draft.miles.map((mile) => mile.recap) },
            takeaway,
          }}
          schema={journeyCompleteSchema(draft.miles.length)}
          onChange={({ arc: { miles, ...arcText }, takeaway: takeawayText }) =>
            update((d) => {
              d.journeyComplete = { arc: arcText, takeaway: takeawayText };
              d.miles.forEach((mile, index) => void (mile.recap = miles[index]));
            })
          }
        />
      </div>
    </div>
  );
};

export default JourneyCompletePanel;
